import React, { createContext, useContext, useState } from 'react';

const JournalSystemContext = createContext();

export const JournalSystemProvider = ({ children }) => {
  const [selectedJournalSystem, setSelectedJournalSystem] = useState('Kaddio');

  return (
    <JournalSystemContext.Provider value={{ selectedJournalSystem, setSelectedJournalSystem }}>
      {children}
    </JournalSystemContext.Provider>
  );
};

export const useJournalSystem = () => {
  const context = useContext(JournalSystemContext);
  if (!context) {
    throw new Error('useJournalSystem must be used within a JournalSystemProvider');
  }
  return context;
};
